import React, { useState } from 'react';
import { useAppContext } from '../store/AppContext';
import SafeIcon from '../common/SafeIcon';
import { FiLock } from 'react-icons/fi';

const Auth = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);
  const { login, t } = useAppContext();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!login(code)) {
      setError(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="bg-slate-800 p-8 rounded-xl shadow-2xl w-full max-w-md border border-slate-700">
        <div className="flex justify-center mb-6">
          <div className="p-4 bg-indigo-600 rounded-full">
            <SafeIcon icon={FiLock} className="text-3xl text-white" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-white text-center mb-8">{t('loginTitle')}</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">
              {t('accessCode')}
            </label>
            <input
              type="password"
              value={code}
              onChange={(e) => { setCode(e.target.value); setError(false); }}
              className="w-full px-4 py-3 bg-slate-900 border border-slate-600 rounded-lg text-white focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-colors"
              placeholder="••••••••••"
            />
          </div>
          {error && <p className="text-red-400 text-sm">{t('invalidCode')}</p>}
          <button
            type="submit"
            className="w-full py-3 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-200"
          >
            {t('loginBtn')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;